/**
 * ADGMQ
 * imedia
 *
 * Navigation component
 */

(function($) {
  $(window).scroll(function() {
    fixNavigationOnScroll();
  });

  $(document).ready(function() {
    fixNavigationOnScroll();
  });

  /**
   * Toogle navigation
   */
  $('button.navbar-toggle').click(function() {
    $('body').toggleClass('nav-open');
  });

  /**
   * Fix navigation
   */
  function fixNavigationOnScroll() {
    var scrollTop = $(window).scrollTop();
    var headerScrollOffset = parseInt(50);

    if (scrollTop > headerScrollOffset) {
      $('body').addClass('nav-fixed');
    } else {
      $('body').removeClass('nav-fixed');
    }
  }

  // Select all links with hashes
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();

          $('html, body').animate(
            {
              scrollTop: target.offset().top - 70,
            },
            1000,
          );
          window.location.hash = this.hash;
        }
      }
    });
})(jQuery);
